<template>
  <div class="course-content">
    <div class="course-list">
      <div class="course-item" v-for="(item, index) in courseList" :key="index">
        <img class="course-image" :src="item.image" alt="" />
        <div class="course-title">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      courseList: [
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/26ff7e5d5e3ff6517dae41b187cd3b00.webp',
          title: '· 马甲线雕刻'
        },
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/40c9371757c7ca46d2643a562b5a1668.webp',
          title: '· 女性抗衰保养'
        },
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3465dc360a35b75982618981a04dd87e.webp',
          title: '· 腹直肌修复'
        },
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ec0ff6ae8ecdda8ffc55ed6c017777e3.webp',
          title: '· 长辈慢性病调理'
        },
        {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/196da4ab3c0206aced8aae6def19ce31.webp',
          title: '· 小孩营养干预'
        }
      ]
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.course-content {
  overflow-y: scroll;
  .course-list {
    padding: 0px 17px;
    display: inline-flex;
    align-items: center;
    .course-item {
      margin-right: 9px;
      .course-image {
        width: 150px;
        height: 80px;
        border-radius: 8px;
        overflow: hidden;
        object-fit: cover;
        margin-bottom: 9px;
      }
      .course-title {
        font-family: MiSans, MiSans;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.8);
        line-height: 19px;
      }
    }
    .course-item:last-child {
      margin-right: 0;
    }
  }
}
</style>
